import { useState, useCallback, useEffect, useRef } from 'react'
import { useLocation } from '@fs/zion-router'
import useWindowFocus from './useWindowFocus'
import useServiceWorkerUpdates from './useServiceWorkerUpdates'

export const useReloadWhenReady = (location, state) => {
  const hasReloaded = useRef(false)

  useEffect(() => {
    if (
      state.doHardReloadOnNextOpportunity &&
      window.location.href !== state.locationWhenUpdatesFound &&
      !hasReloaded.current
    ) {
      // We only want to reload when users has transitioned to a new page
      hasReloaded.current = true
      window.location.reload()
    }
  }, [location, state.doHardReloadOnNextOpportunity, state.locationWhenUpdatesFound])
}

// This hook will check for service worker updates on app focus, will install them on navigation change
export default function useServiceWorkerUpdater() {
  const [state, setState] = useState({
    doHardReloadOnNextOpportunity: false,
    locationWhenUpdatesFound: null,
  })

  const location = useLocation()

  const onUpdateActive = useCallback(() => {
    try {
      setState((prevState) => ({
        ...prevState,
        locationWhenUpdatesFound: window.location.href,
        doHardReloadOnNextOpportunity: true,
      }))
    } catch (error) {
      console.error('Error checking for updates:', error)
    }
  }, [setState])

  const checkForUpdates = useServiceWorkerUpdates(onUpdateActive)
  useWindowFocus(checkForUpdates)
  useReloadWhenReady(location, state)
}
